/* eslint-disable no-console */
import { ERROR_FETCHING_ROSTER_STATS, ERROR_FETCHING_STATS } from '../../../../catalog/NotificationsComments';
import { isValidObject, isValidStat } from '../../../../catalog/Validity';
import { fetchGamePlayersFirestoreAPI } from '../../../../firebase/firebaseAPICalls/FirebaseAPICallsGamePlayer';
import { fetchPlayerFirestoreAPI, fetchAlumniFirestoreAPI, fetchPlayersFirestoreAPI } from '../../../../firebase/firebaseAPICalls/FirebaseAPICallsPlayer';
import { fetchPreDevelopedLeaguesFirestoreAPI } from '../../../../firebase/firebaseAPICalls/FirebaseAPICallsPreDevelopedLeague';
import { fetchPreDevelopedSeasonsFirestoreAPI } from '../../../../firebase/firebaseAPICalls/FirebaseAPICallsPreDevelopedSeason';
import { fetchOpponentFirestoreAPI } from '../../../../firebase/firebaseAPICalls/FirebaseAPICallsOpponent';
import { optimXTesting } from '../../../../catalog/TeamInfo';
import { sendErrorAnalytics } from '../../../../catalog/Analytics';

export const fetchLacrosseGamePlayersAPI = async (sportsType, teamId, alumni, setState, snackbar) => {
    try {
        const finalPlayers = [];

        const players = [];
        let docs;
        if (alumni) {
            docs = await fetchAlumniFirestoreAPI(teamId);
        } else {
            docs = await fetchPlayersFirestoreAPI(teamId);
        }
        docs.forEach((doc) => {
            if (doc.exists) {
                players.push({ ...doc.data() });
            }
        });

        await Promise.all(players.map(async (player) => {
            if (isValidObject(player)) {
                const playerId = player.id;
                const initialStatObject = {
                    gamesPlayed: 0,
                    wins: 0,
                    losses: 0,
                    ties: 0,
                    shutOuts: 0,
                    goals: 0,
                    assists: 0,
                    shots: 0,
                    blocks: 0,
                    groundBalls: 0,
                    turnOvers: 0,
                    bodyChecks: 0,
                    faceOffWins: 0,
                    penalties: 0,
                    penaltyMinutes: 0,
                    emptyNetGoals: 0,
                    gameWinningGoals: 0,
                    powerPlayGoals: 0,
                    shortHandedGoals: 0,
                    goalieGoalsConceded: 0,
                    saves: 0,
                    goalieMinutes: 0,
                    goalieEmptyNetGoals: 0,
                    goalieGameWinningGoals: 0,
                    goaliePowerPlayGoals: 0,
                    goalieShortHandedGoals: 0,
                    goalieShotsOnGoal: 0,
                    goalieShotsSaved: 0,
                };

                const stats = new Map();
                const gamePlayersDocs = await fetchGamePlayersFirestoreAPI(teamId, playerId);
                gamePlayersDocs.forEach((gamePlayersDoc) => {
                    const gamePlayer = gamePlayersDoc.data();
                    if (gamePlayersDoc.exists && isValidObject(gamePlayer)) {
                        if (stats.has(gamePlayer.preDevelopedSeasonId)) {
                            if (!stats.get(gamePlayer.preDevelopedSeasonId)?.has(gamePlayer.preDevelopedLeagueId)) {
                                stats.get(gamePlayer.preDevelopedSeasonId)?.set(gamePlayer.preDevelopedLeagueId, initialStatObject);
                            }
                        } else {
                            stats.set(gamePlayer.preDevelopedSeasonId, new Map());
                            stats.get(gamePlayer.preDevelopedSeasonId)?.set(gamePlayer.preDevelopedLeagueId, initialStatObject);
                        }

                        const newStatObject = { ...stats.get(gamePlayer.preDevelopedSeasonId)?.get(gamePlayer.preDevelopedLeagueId) };
                        newStatObject.gamesPlayed += 1;
                        newStatObject.wins += gamePlayer.winOrLoss === 'win' ? 1 : 0;
                        newStatObject.losses += gamePlayer.winOrLoss === 'loss' ? 1 : 0;
                        newStatObject.ties += gamePlayer.winOrLoss === 'tied' ? 1 : 0;
                        newStatObject.shutOuts += gamePlayer.shutOut ? 1 : 0;
                        newStatObject.goals += gamePlayer.goals;
                        newStatObject.assists += gamePlayer.assists;
                        newStatObject.shots += gamePlayer.shots;
                        newStatObject.blocks += gamePlayer.blocks;
                        newStatObject.groundBalls += gamePlayer.groundBalls;
                        newStatObject.turnOvers += gamePlayer.turnOvers;
                        newStatObject.bodyChecks += gamePlayer.bodyChecks;
                        newStatObject.faceOffWins += gamePlayer.faceOffWins;
                        newStatObject.penalties += gamePlayer.penalties;
                        newStatObject.penaltyMinutes += gamePlayer.penaltyMinutes / 60;
                        newStatObject.emptyNetGoals += gamePlayer.emptyNetGoals;
                        newStatObject.gameWinningGoals += gamePlayer.gameWinningGoals;
                        newStatObject.powerPlayGoals += gamePlayer.powerPlayGoals;
                        newStatObject.shortHandedGoals += gamePlayer.shortHandedGoals;
                        newStatObject.goalieGoalsConceded += gamePlayer.goalieGoalsConceded;
                        newStatObject.saves += gamePlayer.saves;
                        newStatObject.goalieMinutes += gamePlayer.goalieMinutes;
                        newStatObject.goalieEmptyNetGoals += gamePlayer.goalieEmptyNetGoals;
                        newStatObject.goalieGameWinningGoals += gamePlayer.goalieGameWinningGoals;
                        newStatObject.goaliePowerPlayGoals += gamePlayer.goaliePowerPlayGoals;
                        newStatObject.goalieShortHandedGoals += gamePlayer.goalieShortHandedGoals;
                        newStatObject.goalieShotsOnGoal += gamePlayer.goalieShotsOnGoal;
                        newStatObject.goalieShotsSaved += gamePlayer.goalieShotsSaved;

                        stats.get(gamePlayer.preDevelopedSeasonId)?.set(gamePlayer.preDevelopedLeagueId, newStatObject);
                    }
                });

                const { overridingStats } = player;
                Object.entries(overridingStats).forEach((overridingStat) => {
                    const [seasonId, leagueObjects] = overridingStat;
                    Object.entries(leagueObjects).forEach((leagueObject) => {
                        const [leagueId, statObject] = leagueObject;
                        if (stats.has(seasonId)) {
                            if (stats.get(seasonId)?.has(leagueId)) {
                                const newStatObject = { ...stats.get(seasonId)?.get(leagueId) };
                                newStatObject.gamesPlayed = isValidStat(statObject.gamesPlayed) ? statObject.gamesPlayed : newStatObject.gamesPlayed;
                                newStatObject.wins = isValidStat(statObject.wins) ? statObject.wins : newStatObject.wins;
                                newStatObject.losses = isValidStat(statObject.losses) ? statObject.losses : newStatObject.losses;
                                newStatObject.ties = isValidStat(statObject.ties) ? statObject.ties : newStatObject.ties;
                                newStatObject.shutOuts = isValidStat(statObject.shutOuts) ? statObject.shutOuts : newStatObject.shutOuts;
                                newStatObject.goals = isValidStat(statObject.goals) ? statObject.goals : newStatObject.goals;
                                newStatObject.assists = isValidStat(statObject.assists) ? statObject.assists : newStatObject.assists;
                                newStatObject.shots = isValidStat(statObject.shots) ? statObject.shots : newStatObject.shots;
                                newStatObject.blocks = isValidStat(statObject.blocks) ? statObject.blocks : newStatObject.blocks;
                                newStatObject.bodyChecks = isValidStat(statObject.bodyChecks) ? statObject.bodyChecks : newStatObject.bodyChecks;
                                newStatObject.groundBalls = isValidStat(statObject.groundBalls) ? statObject.groundBalls : newStatObject.groundBalls;
                                newStatObject.turnOvers = isValidStat(statObject.turnOvers) ? statObject.turnOvers : newStatObject.turnOvers;
                                newStatObject.faceOffWins = isValidStat(statObject.faceOffWins) ? statObject.faceOffWins : newStatObject.faceOffWins;
                                newStatObject.penalties = isValidStat(statObject.penalties) ? statObject.penalties : newStatObject.penalties;
                                newStatObject.penaltyMinutes = isValidStat(statObject.penaltyMinutes) ? statObject.penaltyMinutes : newStatObject.penaltyMinutes;
                                newStatObject.emptyNetGoals = isValidStat(statObject.emptyNetGoals) ? statObject.emptyNetGoals : newStatObject.emptyNetGoals;
                                newStatObject.gameWinningGoals = isValidStat(statObject.gameWinningGoals) ? statObject.gameWinningGoals : newStatObject.gameWinningGoals;
                                newStatObject.powerPlayGoals = isValidStat(statObject.powerPlayGoals) ? statObject.powerPlayGoals : newStatObject.powerPlayGoals;
                                newStatObject.shortHandedGoals = isValidStat(statObject.shortHandedGoals) ? statObject.shortHandedGoals : newStatObject.shortHandedGoals;
                                newStatObject.goalieGoalsConceded = isValidStat(statObject.goalieGoalsConceded) ? statObject.goalieGoalsConceded : newStatObject.goalieGoalsConceded;
                                newStatObject.saves = isValidStat(statObject.saves) ? statObject.saves : newStatObject.saves;
                                newStatObject.goalieMinutes = isValidStat(statObject.goalieMinutes) ? statObject.goalieMinutes : newStatObject.goalieMinutes;
                                newStatObject.goalieEmptyNetGoals = isValidStat(statObject.goalieEmptyNetGoals) ? statObject.goalieEmptyNetGoals : newStatObject.goalieEmptyNetGoals;
                                newStatObject.goalieGameWinningGoals = isValidStat(statObject.goalieGameWinningGoals) ? statObject.goalieGameWinningGoals : newStatObject.goalieGameWinningGoals;
                                newStatObject.goaliePowerPlayGoals = isValidStat(statObject.goaliePowerPlayGoals) ? statObject.goaliePowerPlayGoals : newStatObject.goaliePowerPlayGoals;
                                newStatObject.goalieShortHandedGoals = isValidStat(statObject.goalieShortHandedGoals) ? statObject.goalieShortHandedGoals : newStatObject.goalieShortHandedGoals;
                                newStatObject.goalieShotsOnGoal = isValidStat(statObject.goalieShotsOnGoal) ? statObject.goalieShotsOnGoal : newStatObject.goalieShotsOnGoal;
                                newStatObject.goalieShotsSaved = isValidStat(statObject.goalieShotsSaved) ? statObject.goalieShotsSaved : newStatObject.goalieShotsSaved;
                                stats.get(seasonId)?.set(leagueId, newStatObject);
                            } else {
                                stats.get(seasonId)?.set(leagueId, {
                                    gamesPlayed: isValidStat(statObject.gamesPlayed) ? statObject.gamesPlayed : 0,
                                    wins: isValidStat(statObject.wins) ? statObject.wins : 0,
                                    losses: isValidStat(statObject.losses) ? statObject.losses : 0,
                                    ties: isValidStat(statObject.ties) ? statObject.ties : 0,
                                    shutOuts: isValidStat(statObject.shutOuts) ? statObject.shutOuts : 0,
                                    goals: isValidStat(statObject.goals) ? statObject.goals : 0,
                                    assists: isValidStat(statObject.assists) ? statObject.assists : 0,
                                    shots: isValidStat(statObject.shots) ? statObject.shots : 0,
                                    blocks: isValidStat(statObject.blocks) ? statObject.blocks : 0,
                                    bodyChecks: isValidStat(statObject.bodyChecks) ? statObject.bodyChecks : 0,
                                    groundBalls: isValidStat(statObject.groundBalls) ? statObject.groundBalls : 0,
                                    turnOvers: isValidStat(statObject.turnOvers) ? statObject.turnOvers : 0,
                                    faceOffWins: isValidStat(statObject.faceOffWins) ? statObject.faceOffWins : 0,
                                    penalties: isValidStat(statObject.penalties) ? statObject.penalties : 0,
                                    penaltyMinutes: isValidStat(statObject.penaltyMinutes) ? statObject.penaltyMinutes : 0,
                                    emptyNetGoals: isValidStat(statObject.emptyNetGoals) ? statObject.emptyNetGoals : 0,
                                    gameWinningGoals: isValidStat(statObject.gameWinningGoals) ? statObject.gameWinningGoals : 0,
                                    powerPlayGoals: isValidStat(statObject.powerPlayGoals) ? statObject.powerPlayGoals : 0,
                                    shortHandedGoals: isValidStat(statObject.shortHandedGoals) ? statObject.shortHandedGoals : 0,
                                    goalieGoalsConceded: isValidStat(statObject.goalieGoalsConceded) ? statObject.goalieGoalsConceded : 0,
                                    saves: isValidStat(statObject.saves) ? statObject.saves : 0,
                                    goalieMinutes: isValidStat(statObject.goalieMinutes) ? statObject.goalieMinutes : 0,
                                    goalieEmptyNetGoals: isValidStat(statObject.goalieEmptyNetGoals) ? statObject.goalieEmptyNetGoals : 0,
                                    goalieGameWinningGoals: isValidStat(statObject.goalieGameWinningGoals) ? statObject.goalieGameWinningGoals : 0,
                                    goaliePowerPlayGoals: isValidStat(statObject.goaliePowerPlayGoals) ? statObject.goaliePowerPlayGoals : 0,
                                    goalieShortHandedGoals: isValidStat(statObject.goalieShortHandedGoals) ? statObject.goalieShortHandedGoals : 0,
                                    goalieShotsOnGoal: isValidStat(statObject.goalieShotsOnGoal) ? statObject.goalieShotsOnGoal : 0,
                                    goalieShotsSaved: isValidStat(statObject.goalieShotsSaved) ? statObject.goalieShotsSaved : 0,
                                });
                            }
                        } else {
                            stats.set(seasonId, new Map());
                            stats.get(seasonId)?.set(leagueId, {
                                gamesPlayed: isValidStat(statObject.gamesPlayed) ? statObject.gamesPlayed : 0,
                                wins: isValidStat(statObject.wins) ? statObject.wins : 0,
                                losses: isValidStat(statObject.losses) ? statObject.losses : 0,
                                ties: isValidStat(statObject.ties) ? statObject.ties : 0,
                                shutOuts: isValidStat(statObject.shutOuts) ? statObject.shutOuts : 0,
                                goals: isValidStat(statObject.goals) ? statObject.goals : 0,
                                assists: isValidStat(statObject.assists) ? statObject.assists : 0,
                                shots: isValidStat(statObject.shots) ? statObject.shots : 0,
                                blocks: isValidStat(statObject.blocks) ? statObject.blocks : 0,
                                bodyChecks: isValidStat(statObject.bodyChecks) ? statObject.bodyChecks : 0,
                                groundBalls: isValidStat(statObject.groundBalls) ? statObject.groundBalls : 0,
                                turnOvers: isValidStat(statObject.turnOvers) ? statObject.turnOvers : 0,
                                faceOffWins: isValidStat(statObject.faceOffWins) ? statObject.faceOffWins : 0,
                                penalties: isValidStat(statObject.penalties) ? statObject.penalties : 0,
                                penaltyMinutes: isValidStat(statObject.penaltyMinutes) ? statObject.penaltyMinutes : 0,
                                emptyNetGoals: isValidStat(statObject.emptyNetGoals) ? statObject.emptyNetGoals : 0,
                                gameWinningGoals: isValidStat(statObject.gameWinningGoals) ? statObject.gameWinningGoals : 0,
                                powerPlayGoals: isValidStat(statObject.powerPlayGoals) ? statObject.powerPlayGoals : 0,
                                shortHandedGoals: isValidStat(statObject.shortHandedGoals) ? statObject.shortHandedGoals : 0,
                                goalieGoalsConceded: isValidStat(statObject.goalieGoalsConceded) ? statObject.goalieGoalsConceded : 0,
                                saves: isValidStat(statObject.saves) ? statObject.saves : 0,
                                goalieMinutes: isValidStat(statObject.goalieMinutes) ? statObject.goalieMinutes : 0,
                                goalieEmptyNetGoals: isValidStat(statObject.goalieEmptyNetGoals) ? statObject.goalieEmptyNetGoals : 0,
                                goalieGameWinningGoals: isValidStat(statObject.goalieGameWinningGoals) ? statObject.goalieGameWinningGoals : 0,
                                goaliePowerPlayGoals: isValidStat(statObject.goaliePowerPlayGoals) ? statObject.goaliePowerPlayGoals : 0,
                                goalieShortHandedGoals: isValidStat(statObject.goalieShortHandedGoals) ? statObject.goalieShortHandedGoals : 0,
                                goalieShotsOnGoal: isValidStat(statObject.goalieShotsOnGoal) ? statObject.goalieShotsOnGoal : 0,
                                goalieShotsSaved: isValidStat(statObject.goalieShotsSaved) ? statObject.goalieShotsSaved : 0,
                            });
                        }
                    });
                });

                const preDevelopedSeasons = new Map();
                const preDevelopedLeagues = new Map();
                const seasonDocs = await fetchPreDevelopedSeasonsFirestoreAPI(sportsType);
                seasonDocs.forEach((doc) => {
                    if (doc.exists) {
                        preDevelopedSeasons.set(doc.data().id, doc.data().name);
                    }
                });
                const leagueDocs = await fetchPreDevelopedLeaguesFirestoreAPI(sportsType);
                leagueDocs.forEach((doc) => {
                    if (doc.exists) {
                        preDevelopedLeagues.set(doc.data().id, `${doc.data().name}${doc.data().division !== '-1' ? ` - ${doc.data().division}` : ''}`);
                    }
                });

                let finalStats = new Map();
                stats.forEach((leagueObjects, seasonId) => {
                    const seasonName = preDevelopedSeasons.get(seasonId);
                    finalStats.set(seasonName, new Map());
                    leagueObjects.forEach((statObject, leagueId) => {
                        const leagueName = preDevelopedLeagues.get(leagueId);
                        finalStats.get(seasonName)?.set(leagueName, statObject);
                    });
                    finalStats.set(seasonName, new Map([...finalStats.get(seasonName).entries()].sort()));
                });
                finalStats = new Map([...finalStats.entries()].sort());

                const finalfinalStats = [];
                finalStats.forEach((leagueObjects, seasonName) => {
                    leagueObjects.forEach((statObject, leagueName) => {
                        finalfinalStats.push({ seasonName, leagueName, ...statObject });
                    });
                });

                finalPlayers.push({ ...player, stats: finalfinalStats });
            }
        }));

        setState({ type: 'fetchPlayersStats', players: finalPlayers });
    } catch (error) {
        sendErrorAnalytics(ERROR_FETCHING_ROSTER_STATS);
        if (optimXTesting) {
            snackbar(ERROR_FETCHING_ROSTER_STATS, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLacrosseGamePlayerAPI = async (sportsType, teamId, playerId, setState, snackbar) => {
    try {
        const initialStatObject = {
            gamesPlayed: 0,
            wins: 0,
            losses: 0,
            ties: 0,
            shutOuts: 0,
            goals: 0,
            assists: 0,
            shots: 0,
            blocks: 0,
            turnOvers: 0,
            groundBalls: 0,
            bodyChecks: 0,
            faceOffWins: 0,
            penalties: 0,
            penaltyMinutes: 0,
            emptyNetGoals: 0,
            gameWinningGoals: 0,
            powerPlayGoals: 0,
            shortHandedGoals: 0,
            goalieGoalsConceded: 0,
            saves: 0,
            goalieMinutes: 0,
            goalieEmptyNetGoals: 0,
            goalieGameWinningGoals: 0,
            goaliePowerPlayGoals: 0,
            goalieShortHandedGoals: 0,
            goalieShotsOnGoal: 0,
            goalieShotsSaved: 0,
        };

        const stats = new Map();
        const gameLogs = [];
        const gamePlayersDocs = await fetchGamePlayersFirestoreAPI(teamId, playerId);
        gamePlayersDocs.forEach((gamePlayersDoc) => {
            const gamePlayer = gamePlayersDoc.data();
            if (gamePlayersDoc.exists && isValidObject(gamePlayer)) {
                if (stats.has(gamePlayer.preDevelopedSeasonId)) {
                    if (!stats.get(gamePlayer.preDevelopedSeasonId)?.has(gamePlayer.preDevelopedLeagueId)) {
                        stats.get(gamePlayer.preDevelopedSeasonId)?.set(gamePlayer.preDevelopedLeagueId, initialStatObject);
                    }
                } else {
                    stats.set(gamePlayer.preDevelopedSeasonId, new Map());
                    stats.get(gamePlayer.preDevelopedSeasonId)?.set(gamePlayer.preDevelopedLeagueId, initialStatObject);
                }

                const newStatObject = { ...stats.get(gamePlayer.preDevelopedSeasonId)?.get(gamePlayer.preDevelopedLeagueId) };
                newStatObject.gamesPlayed += 1;
                newStatObject.wins += gamePlayer.winOrLoss === 'win' ? 1 : 0;
                newStatObject.losses += gamePlayer.winOrLoss === 'loss' ? 1 : 0;
                newStatObject.ties += gamePlayer.winOrLoss === 'tied' ? 1 : 0;
                newStatObject.shutOuts += gamePlayer.shutOut ? 1 : 0;
                newStatObject.goals += gamePlayer.goals;
                newStatObject.assists += gamePlayer.assists;
                newStatObject.shots += gamePlayer.shots;
                newStatObject.blocks += gamePlayer.blocks;
                newStatObject.bodyChecks += gamePlayer.bodyChecks;
                newStatObject.groundBalls += gamePlayer.groundBalls;
                newStatObject.turnOvers += gamePlayer.turnOvers;
                newStatObject.faceOffWins += gamePlayer.faceOffWins;
                newStatObject.penalties += gamePlayer.penalties;
                newStatObject.penaltyMinutes += gamePlayer.penaltyMinutes / 60;
                newStatObject.emptyNetGoals += gamePlayer.emptyNetGoals;
                newStatObject.gameWinningGoals += gamePlayer.gameWinningGoals;
                newStatObject.powerPlayGoals += gamePlayer.powerPlayGoals;
                newStatObject.shortHandedGoals += gamePlayer.shortHandedGoals;
                newStatObject.goalieGoalsConceded += gamePlayer.goalieGoalsConceded;
                newStatObject.saves += gamePlayer.saves;
                newStatObject.goalieMinutes += gamePlayer.goalieMinutes;
                newStatObject.goalieEmptyNetGoals += gamePlayer.goalieEmptyNetGoals;
                newStatObject.goalieGameWinningGoals += gamePlayer.goalieGameWinningGoals;
                newStatObject.goaliePowerPlayGoals += gamePlayer.goaliePowerPlayGoals;
                newStatObject.goalieShortHandedGoals += gamePlayer.goalieShortHandedGoals;
                newStatObject.goalieShotsOnGoal += gamePlayer.goalieShotsOnGoal;
                newStatObject.goalieShotsSaved += gamePlayer.goalieShotsSaved;

                stats.get(gamePlayer.preDevelopedSeasonId)?.set(gamePlayer.preDevelopedLeagueId, newStatObject);

                gameLogs.push({
                    seasonId: gamePlayer.preDevelopedSeasonId,
                    leagueId: gamePlayer.preDevelopedLeagueId,
                    opponentId: gamePlayer.opponentId,
                    timeOfGame: gamePlayer.timeOfGame,
                    homeGame: gamePlayer.homeGame,
                    winOrLoss: gamePlayer.winOrLoss,
                    gameScore: gamePlayer.gameScore,
                    shutOut: gamePlayer.shutOut,
                    goals: gamePlayer.goals,
                    assists: gamePlayer.assists,
                    shots: gamePlayer.shots,
                    blocks: gamePlayer.blocks,
                    bodyChecks: gamePlayer.bodyChecks,
                    groundBalls: gamePlayer.groundBalls,
                    turnOvers: gamePlayer.turnOvers,
                    faceOffWins: gamePlayer.faceOffWins,
                    penalties: gamePlayer.penalties,
                    penaltyMinutes: gamePlayer.penaltyMinutes / 60,
                    emptyNetGoals: gamePlayer.emptyNetGoals,
                    gameWinningGoals: gamePlayer.gameWinningGoals,
                    powerPlayGoals: gamePlayer.powerPlayGoals,
                    shortHandedGoals: gamePlayer.shortHandedGoals,
                    goalieGoalsConceded: gamePlayer.goalieGoalsConceded,
                    saves: gamePlayer.saves,
                    goalieMinutes: gamePlayer.goalieMinutes,
                    goalieEmptyNetGoals: gamePlayer.goalieEmptyNetGoals,
                    goalieGameWinningGoals: gamePlayer.goalieGameWinningGoals,
                    goaliePowerPlayGoals: gamePlayer.goaliePowerPlayGoals,
                    goalieShortHandedGoals: gamePlayer.goalieShortHandedGoals,
                    goalieShotsOnGoal: gamePlayer.goalieShotsOnGoal,
                    goalieShotsSaved: gamePlayer.goalieShotsSaved,
                });
            }
        });

        const playerDoc = await fetchPlayerFirestoreAPI(playerId);
        const player = playerDoc.data();
        if (playerDoc.exists && isValidObject(player)) {
            const { overridingStats } = player;
            Object.entries(overridingStats).forEach((overridingStat) => {
                const [seasonId, leagueObjects] = overridingStat;
                Object.entries(leagueObjects).forEach((leagueObject) => {
                    const [leagueId, statObject] = leagueObject;
                    if (stats.has(seasonId)) {
                        if (stats.get(seasonId)?.has(leagueId)) {
                            const newStatObject = { ...stats.get(seasonId)?.get(leagueId) };
                            newStatObject.gamesPlayed = isValidStat(statObject.gamesPlayed) ? statObject.gamesPlayed : newStatObject.gamesPlayed;
                            newStatObject.wins = isValidStat(statObject.wins) ? statObject.wins : newStatObject.wins;
                            newStatObject.losses = isValidStat(statObject.losses) ? statObject.losses : newStatObject.losses;
                            newStatObject.ties = isValidStat(statObject.ties) ? statObject.ties : newStatObject.ties;
                            newStatObject.shutOuts = isValidStat(statObject.shutOuts) ? statObject.shutOuts : newStatObject.shutOuts;
                            newStatObject.goals = isValidStat(statObject.goals) ? statObject.goals : newStatObject.goals;
                            newStatObject.assists = isValidStat(statObject.assists) ? statObject.assists : newStatObject.assists;
                            newStatObject.shots = isValidStat(statObject.shots) ? statObject.shots : newStatObject.shots;
                            newStatObject.blocks = isValidStat(statObject.blocks) ? statObject.blocks : newStatObject.blocks;
                            newStatObject.bodyChecks = isValidStat(statObject.bodyChecks) ? statObject.bodyChecks : newStatObject.bodyChecks;
                            newStatObject.groundBalls = isValidStat(statObject.groundBalls) ? statObject.groundBalls : newStatObject.groundBalls;
                            newStatObject.turnOvers = isValidStat(statObject.turnOvers) ? statObject.turnOvers : newStatObject.turnOvers;
                            newStatObject.faceOffWins = isValidStat(statObject.faceOffWins) ? statObject.faceOffWins : newStatObject.faceOffWins;
                            newStatObject.penalties = isValidStat(statObject.penalties) ? statObject.penalties : newStatObject.penalties;
                            newStatObject.penaltyMinutes = isValidStat(statObject.penaltyMinutes) ? statObject.penaltyMinutes : newStatObject.penaltyMinutes;
                            newStatObject.emptyNetGoals = isValidStat(statObject.emptyNetGoals) ? statObject.emptyNetGoals : newStatObject.emptyNetGoals;
                            newStatObject.gameWinningGoals = isValidStat(statObject.gameWinningGoals) ? statObject.gameWinningGoals : newStatObject.gameWinningGoals;
                            newStatObject.powerPlayGoals = isValidStat(statObject.powerPlayGoals) ? statObject.powerPlayGoals : newStatObject.powerPlayGoals;
                            newStatObject.shortHandedGoals = isValidStat(statObject.shortHandedGoals) ? statObject.shortHandedGoals : newStatObject.shortHandedGoals;
                            newStatObject.goalieGoalsConceded = isValidStat(statObject.goalieGoalsConceded) ? statObject.goalieGoalsConceded : newStatObject.goalieGoalsConceded;
                            newStatObject.saves = isValidStat(statObject.saves) ? statObject.saves : newStatObject.saves;
                            newStatObject.goalieMinutes = isValidStat(statObject.goalieMinutes) ? statObject.goalieMinutes : newStatObject.goalieMinutes;
                            newStatObject.goalieEmptyNetGoals = isValidStat(statObject.goalieEmptyNetGoals) ? statObject.goalieEmptyNetGoals : newStatObject.goalieEmptyNetGoals;
                            newStatObject.goalieGameWinningGoals = isValidStat(statObject.goalieGameWinningGoals) ? statObject.goalieGameWinningGoals : newStatObject.goalieGameWinningGoals;
                            newStatObject.goaliePowerPlayGoals = isValidStat(statObject.goaliePowerPlayGoals) ? statObject.goaliePowerPlayGoals : newStatObject.goaliePowerPlayGoals;
                            newStatObject.goalieShortHandedGoals = isValidStat(statObject.goalieShortHandedGoals) ? statObject.goalieShortHandedGoals : newStatObject.goalieShortHandedGoals;
                            newStatObject.goalieShotsOnGoal = isValidStat(statObject.goalieShotsOnGoal) ? statObject.goalieShotsOnGoal : newStatObject.goalieShotsOnGoal;
                            newStatObject.goalieShotsSaved = isValidStat(statObject.goalieShotsSaved) ? statObject.goalieShotsSaved : newStatObject.goalieShotsSaved;
                            stats.get(seasonId)?.set(leagueId, newStatObject);
                        } else {
                            stats.get(seasonId)?.set(leagueId, {
                                gamesPlayed: isValidStat(statObject.gamesPlayed) ? statObject.gamesPlayed : 0,
                                wins: isValidStat(statObject.wins) ? statObject.wins : 0,
                                losses: isValidStat(statObject.losses) ? statObject.losses : 0,
                                ties: isValidStat(statObject.ties) ? statObject.ties : 0,
                                shutOuts: isValidStat(statObject.shutOuts) ? statObject.shutOuts : 0,
                                goals: isValidStat(statObject.goals) ? statObject.goals : 0,
                                assists: isValidStat(statObject.assists) ? statObject.assists : 0,
                                shots: isValidStat(statObject.shots) ? statObject.shots : 0,
                                blocks: isValidStat(statObject.blocks) ? statObject.blocks : 0,
                                groundBalls: isValidStat(statObject.groundBalls) ? statObject.groundBalls : 0,
                                turnOvers: isValidStat(statObject.turnOvers) ? statObject.turnOvers : 0,
                                bodyChecks: isValidStat(statObject.bodyChecks) ? statObject.bodyChecks : 0,
                                faceOffWins: isValidStat(statObject.faceOffWins) ? statObject.faceOffWins : 0,
                                penalties: isValidStat(statObject.penalties) ? statObject.penalties : 0,
                                penaltyMinutes: isValidStat(statObject.penaltyMinutes) ? statObject.penaltyMinutes : 0,
                                emptyNetGoals: isValidStat(statObject.emptyNetGoals) ? statObject.emptyNetGoals : 0,
                                gameWinningGoals: isValidStat(statObject.gameWinningGoals) ? statObject.gameWinningGoals : 0,
                                powerPlayGoals: isValidStat(statObject.powerPlayGoals) ? statObject.powerPlayGoals : 0,
                                shortHandedGoals: isValidStat(statObject.shortHandedGoals) ? statObject.shortHandedGoals : 0,
                                goalieGoalsConceded: isValidStat(statObject.goalieGoalsConceded) ? statObject.goalieGoalsConceded : 0,
                                saves: isValidStat(statObject.saves) ? statObject.saves : 0,
                                goalieMinutes: isValidStat(statObject.goalieMinutes) ? statObject.goalieMinutes : 0,
                                goalieEmptyNetGoals: isValidStat(statObject.goalieEmptyNetGoals) ? statObject.goalieEmptyNetGoals : 0,
                                goalieGameWinningGoals: isValidStat(statObject.goalieGameWinningGoals) ? statObject.goalieGameWinningGoals : 0,
                                goaliePowerPlayGoals: isValidStat(statObject.goaliePowerPlayGoals) ? statObject.goaliePowerPlayGoals : 0,
                                goalieShortHandedGoals: isValidStat(statObject.goalieShortHandedGoals) ? statObject.goalieShortHandedGoals : 0,
                                goalieShotsOnGoal: isValidStat(statObject.goalieShotsOnGoal) ? statObject.goalieShotsOnGoal : 0,
                                goalieShotsSaved: isValidStat(statObject.goalieShotsSaved) ? statObject.goalieShotsSaved : 0,
                            });
                        }
                    } else {
                        stats.set(seasonId, new Map());
                        stats.get(seasonId)?.set(leagueId, {
                            gamesPlayed: isValidStat(statObject.gamesPlayed) ? statObject.gamesPlayed : 0,
                            wins: isValidStat(statObject.wins) ? statObject.wins : 0,
                            losses: isValidStat(statObject.losses) ? statObject.losses : 0,
                            ties: isValidStat(statObject.ties) ? statObject.ties : 0,
                            shutOuts: isValidStat(statObject.shutOuts) ? statObject.shutOuts : 0,
                            goals: isValidStat(statObject.goals) ? statObject.goals : 0,
                            assists: isValidStat(statObject.assists) ? statObject.assists : 0,
                            shots: isValidStat(statObject.shots) ? statObject.shots : 0,
                            blocks: isValidStat(statObject.blocks) ? statObject.blocks : 0,
                            bodyChecks: isValidStat(statObject.bodyChecks) ? statObject.bodyChecks : 0,
                            groundBalls: isValidStat(statObject.groundBalls) ? statObject.groundBalls : 0,
                            turnOvers: isValidStat(statObject.turnOvers) ? statObject.turnOvers : 0,
                            faceOffWins: isValidStat(statObject.faceOffWins) ? statObject.faceOffWins : 0,
                            penalties: isValidStat(statObject.penalties) ? statObject.penalties : 0,
                            penaltyMinutes: isValidStat(statObject.penaltyMinutes) ? statObject.penaltyMinutes : 0,
                            emptyNetGoals: isValidStat(statObject.emptyNetGoals) ? statObject.emptyNetGoals : 0,
                            gameWinningGoals: isValidStat(statObject.gameWinningGoals) ? statObject.gameWinningGoals : 0,
                            powerPlayGoals: isValidStat(statObject.powerPlayGoals) ? statObject.powerPlayGoals : 0,
                            shortHandedGoals: isValidStat(statObject.shortHandedGoals) ? statObject.shortHandedGoals : 0,
                            goalieGoalsConceded: isValidStat(statObject.goalieGoalsConceded) ? statObject.goalieGoalsConceded : 0,
                            saves: isValidStat(statObject.saves) ? statObject.saves : 0,
                            goalieMinutes: isValidStat(statObject.goalieMinutes) ? statObject.goalieMinutes : 0,
                            goalieEmptyNetGoals: isValidStat(statObject.goalieEmptyNetGoals) ? statObject.goalieEmptyNetGoals : 0,
                            goalieGameWinningGoals: isValidStat(statObject.goalieGameWinningGoals) ? statObject.goalieGameWinningGoals : 0,
                            goaliePowerPlayGoals: isValidStat(statObject.goaliePowerPlayGoals) ? statObject.goaliePowerPlayGoals : 0,
                            goalieShortHandedGoals: isValidStat(statObject.goalieShortHandedGoals) ? statObject.goalieShortHandedGoals : 0,
                            goalieShotsOnGoal: isValidStat(statObject.goalieShotsOnGoal) ? statObject.goalieShotsOnGoal : 0,
                            goalieShotsSaved: isValidStat(statObject.goalieShotsSaved) ? statObject.goalieShotsSaved : 0,
                        });
                    }
                });
            });
        }

        const preDevelopedSeasons = new Map();
        const preDevelopedLeagues = new Map();
        const seasonDocs = await fetchPreDevelopedSeasonsFirestoreAPI(sportsType);
        seasonDocs.forEach((doc) => {
            if (doc.exists) {
                preDevelopedSeasons.set(doc.data().id, doc.data().name);
            }
        });
        const leagueDocs = await fetchPreDevelopedLeaguesFirestoreAPI(sportsType);
        leagueDocs.forEach((doc) => {
            if (doc.exists) {
                preDevelopedLeagues.set(doc.data().id, `${doc.data().name}${doc.data().division !== '-1' ? ` - ${doc.data().division}` : ''}`);
            }
        });

        let finalStats = new Map();
        stats.forEach((leagueObjects, seasonId) => {
            const seasonName = preDevelopedSeasons.get(seasonId);
            finalStats.set(seasonName, new Map());
            leagueObjects.forEach((statObject, leagueId) => {
                const leagueName = preDevelopedLeagues.get(leagueId);
                finalStats.get(seasonName)?.set(leagueName, statObject);
            });
            finalStats.set(seasonName, new Map([...finalStats.get(seasonName).entries()].sort()));
        });
        finalStats = new Map([...finalStats.entries()].sort());

        const finalfinalStats = [];
        finalStats.forEach((leagueObjects, seasonName) => {
            leagueObjects.forEach((statObject, leagueName) => {
                finalfinalStats.push({ seasonName, leagueName, ...statObject });
            });
        });

        const finalGameLogs = Array(gameLogs.length);
        await Promise.all(gameLogs.map(async (log, index) => {
            const seasonName = preDevelopedSeasons.get(gameLogs[index].seasonId);
            const leagueName = preDevelopedLeagues.get(gameLogs[index].leagueId);
            const opponentDoc = await fetchOpponentFirestoreAPI(teamId, gameLogs[index].opponentId);
            let opponentName = '';
            if (opponentDoc.exists && isValidObject(opponentDoc.data())) {
                opponentName = opponentDoc.data().name;
            }
            const finalGameLog = { ...log, seasonName, leagueName, opponentName };
            finalGameLogs[index] = finalGameLog;
        }));

        setState({ type: 'fetchStatsAndGameLogs', stats: finalfinalStats, gameLogs: finalGameLogs });
    } catch (error) {
        sendErrorAnalytics(ERROR_FETCHING_STATS);
        if (optimXTesting) {
            snackbar(ERROR_FETCHING_STATS, { variant: 'error' });
            console.log(error);
        }
    }
};
